import axios from "./axios";
import axiosInstance from "./axios";

export async function GET(url, params) {
    return axiosInstance.get(url, {params})
}

export async function POST(url, data) {
    return axios.post(url, data)
}
export async function PUT(url, data) {
    return axios.put(url, data)
}
export async function DELETE(url, params) {
    return axiosInstance.delete(url, { params });
}
